<template>
  <div class="card mb-4">
    <div class="card-header">
      <div class="row">
        <div class="col-6 d-flex align-items-center">
          <h6 class="mb-0">Komisi Produk</h6>
        </div>
        <div class="col-6 text-end">
          <soft-button
            color="success"
            size="sm"
            variant="outline"
            @click="openModalCreate()"
            >Tambah Baru</soft-button
          >
        </div>
      </div>
    </div>
    <div class="card-body p-0 w-100">
      <div class="table-responsive p-0">
        <good-table-commisions v-bind:commisions="this.dataProductCommissions">
        </good-table-commisions>
      </div>
    </div>
  </div>
  <modal
    :show="modal.status"
    body-classes="p-0"
    modal-classes="modal-dialog-centered modal-md"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-6 d-flex align-items-center">
                <h6 class="mb-0">{{ modal.title }}</h6>
              </div>
              <div class="col-6 text-end">
                <span class="cursor-pointer" @click="this.modal.status = false"
                  >x</span
                >
              </div>
            </div>
          </div>
          <div class="card-body p-3 pb-0 mb-0">
            <div class="mb-4 text-danger" v-for="error in errors" :key="error">
              <div v-if="!!error.forEach">
                <p class="mb-0" v-for="message in error" :key="message">
                  {{ message }}
                </p>
              </div>
            </div>
            <form
              ref="form"
              action="#"
              :method="modal.method"
              role="form"
              class="row"
              v-on:submit.prevent="submit(modal.method)"
            >
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Nama Komisi</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nama Komisi"
                    v-model="commission.name"
                  />
                </div>
                <div class="my-3">
                  <soft-button color="success" size="sm" variant="outline">{{
                    modal.button
                  }}</soft-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
import SoftButton from "@/components/SoftButton.vue";
import Modal from "@/views/components/Modal.vue";
import { sweatalert } from "@/reactivities/sweatalert.js";
import GoodTableCommisions from "./GoodTableCommisions.vue";

export default {
  props: ["productCommissions"],
  name: "table-commissions",
  components: {
    SoftButton,
    Modal,
    GoodTableCommisions,
  },
  data() {
    return {
      dataProductCommissions: this.productCommissions,
      listCategories: null,
      urlCommission: `${this.apiUrl}/product/commission`,
      modal: {
        status: false,
        method: "POST", // default
        title: "",
        button: "Tambah Baru", // default
        methodFuction: "tambahCommission",
      },
      commission: {
        id: "",
        name: "",
      },
      authToken:
        "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken,
      errors: null,
    };
  },
  updated() {
    if (this.dataProductCommissions.length == 0) {
      this.dataProductCommissions = this.productCommissions;
    }
  },
  methods: {
    submit(method) {
      if (method == "POST") {
        this.tambahCommission();
      } else if (method == "PUT") {
        this.editCommission();
      }
    },
    openModalCreate() {
      this.errors = "";

      this.modal.status = true;
      this.modal.method = "POST";
      this.modal.methodFuction = "tambahCommission";
      this.modal.title = "Tambah Komisi";
      this.commission.name = "";
    },
    openModalEdit(commissionId) {
      this.errors = "";

      const selectedCommission = this.productCommissions.find(
        (commission) => commission.id === commissionId
      );

      this.modal.status = true;
      this.modal.method = "PUT";
      this.modal.methodFuction = "updateCommission";
      this.modal.title = "Edit Komisi";
      this.modal.button = "Simpan";
      this.commission.id = selectedCommission.id;
      this.commission.name = selectedCommission.name;
    },
    closeModal() {
      this.modal.status = false;
    },
    appendCommission(dataCommission) {
      this.dataProductCommissions.push(dataCommission);
    },
    tambahCommission: function () {
      axios
        .post(this.urlCommission, this.commission, {
          headers: { Authorization: this.authToken },
        })
        .then((response) => {
          this.appendCommission(response.data.data);

          sweatalert.showAlert("success", response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;

          Object.keys(this.errors).forEach((key) => {
            sweatalert.showAlert("error", this.errors[key]);
          });
        });
    },
    editCommission: function () {
      axios
        .put(this.urlCommission + "/" + this.commission.id, this.commission, {
          headers: { Authorization: this.authToken },
        })
        .then((response) => {
          var _this = this;

          _this.dataProductCommissions.map(function (commission, index) {
            if (commission.id == response.data.data.id) {
              _this.dataProductCommissions[index] = {
                id: response.data.data.id,
                name: response.data.data.name,
              };
            }

            return commission;
          });
          sweatalert.showAlert("success", response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;

          Object.keys(this.errors).forEach((key) => {
            sweatalert.showAlert("error", this.errors[key]);
          });
        });
    },
    deleteCommission: function (commissionId) {
      if (
        confirm(
          "Anda yakin ingin menghapus item ini? Ini tidak dapat dibatalkan."
        )
      ) {
        axios
          .delete(this.urlCommission + "/" + commissionId, {
            headers: { Authorization: this.authToken },
          })
          .then((response) => {
            this.dataProductCommissions = this.dataProductCommissions.filter(
              (commission) => commission.id !== commissionId
            );
            sweatalert.showAlert("success", response.data.message);
          })
          .catch((error) => {
            this.errors = error.response.data.errors;

            Object.keys(this.errors).forEach((key) => {
              sweatalert.showAlert("error", this.errors[key]);
            });
          });
      }
    },
  },
};
</script>
